var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"speedometer"},[_c('AnimatedNumber',{attrs:{"duration":_vm.duration,"format-value":_vm.formatFixed,"value":_vm.value}}),_c('div',[_vm._v("km/h")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }